import dojoTheme from './dojo-theme';
import ascm from './ascm';
export default {
    theme: Object.assign({}, dojoTheme.theme, ascm.theme),
    variants: {
        default: dojoTheme.variants.default,
        cscp: ascm.variants.cscp,
        cltd: ascm.variants.cltd,
        cpim: ascm.variants.cpim,
        ctsc: ascm.variants.ctsc,
        ascmpreview: ascm.variants.ascmpreview,
        ascm2024demo: ascm.variants.ascm2024demo,
        cscp2024: ascm.variants.cscp2024,
        cscp2024ss: ascm.variants.cscp2024ss,
        cltd2024: ascm.variants.cltd2024,
        cltd2024ss: ascm.variants.cltd2024ss,
        cpim2024: ascm.variants.cpim2024,
        cpim2024ss: ascm.variants.cpim2024ss,
        ctsc2024: ascm.variants.ctsc2024,
        ctsc2024ss: ascm.variants.ctsc2024ss
    }
};
